import type { TasAsset } from './tas-asset.type.ts';
import type { DigitalAssetTraitExtension } from '../traits/digital-asset.ext.ts';
// tas-asset is a digital-asset: it carries the digital-asset trait fields
// (filename, tags, classification, ...) and the legacy Model inherited the
// trait's computed getters (presentableName, aiValidationDisplayStatus,
// employeeSelectedType, ...). Compose the trait extension so those getters are
// part of the tas-asset record type as well.
export interface TasAssetExtension extends TasAsset, DigitalAssetTraitExtension {}
export class TasAssetExtension {
  // ── Computed Properties ──
  get extension() {
    const parts = this.filename.split('.');
    return parts.length > 1 ? parts.pop()!.toLowerCase() : '';
  }
}

const Registration = {
  kind: 'object',
  name: 'tas-asset',
  features: TasAssetExtension,
};
export default Registration;
